import React, {useEffect, useState, useRef} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./Header";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {faLinkedin, faSquareLinkedin, faSquareInstagram} from "@fortawesome/free-brands-svg-icons";
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';

const MainLayout = (props) => {
    return (
      <div className="mainlayout-maindiv">
        <Header />
        <div className="mainlayout-body">{props.children}</div>
        <Footer />
      </div>
    );
}

export default MainLayout